import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "children", "icon", "iconSpacing", "iconOffset", "inline"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Box from 'components/Box';
import Flag from 'components/Flag';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
function Hint(_ref) {
  var id = _ref.id,
    children = _ref.children,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'info' : _ref$icon,
    _ref$iconSpacing = _ref.iconSpacing,
    iconSpacing = _ref$iconSpacing === void 0 ? 'xs' : _ref$iconSpacing,
    iconOffset = _ref.iconOffset,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    as: inline ? 'span' : undefined
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsx(Flag, {
      inline: inline,
      align: "top",
      spacing: iconSpacing,
      token: /*#__PURE__*/_jsx(Icon, {
        dimmed: true,
        name: icon,
        color: icon === 'warning' ? 'negative' : undefined
      }),
      tokenOffset: iconOffset,
      children: /*#__PURE__*/_jsx(Text, {
        as: inline ? 'span' : undefined,
        size: "s",
        id: id,
        children: children
      })
    })
  }));
}
export default Hint;